import styled, { css } from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';
import Button from '@prisjakt/ui-button';
import TooltipComponent from '@prisjakt/ui-tooltip-new';

const sharedCompareButtonStyled = css`
  align-items: center;
  align-self: stretch;
  outline: none;
  cursor: pointer;
  position: relative;
`;

const Tooltip = styled(TooltipComponent)``;

type CompareProductButtonProps = { selected?: boolean };
const CompareProductButtonMobile = styled(Button)<CompareProductButtonProps>`
  display: none;
  width: 100%;
  background-color: transparent;
  ${sharedCompareButtonStyled};

  ${media.mediumDown`display: flex;`}

  ${props =>
    props.selected &&
    css`
      background-color: ${props.theme.bg.productCompare};
      border-color: ${props.theme.bg.productCompare};
      color: ${props.theme.text.primary};

      &:active,
      &:hover,
      &:focus {
        background-color: ${props.theme.bg.productCompare};
        border-color: ${props.theme.bg.productCompare};
        color: ${props.theme.text.primary};
      }
    `};
`;

const CompareProductButtonDesktop = styled.button`
  display: none;
  padding: 0 ${layout.spacing.xxSmall};
  ${sharedCompareButtonStyled};

  ${media.largeUp`display: flex;`}
`;

const Title = styled.span`
  display: none;

  ${media.mediumDown`
    display: block;
  `}
`;

type CompareIconWrapperProps = { active?: boolean };
export const CompareIconWrapper = styled.div<CompareIconWrapperProps>`
  background-color: ${({ theme, active }) =>
    active ? theme.bg.productCompare : 'transparent'};
  border-radius: ${layout.borderRadius};
  color: ${({ theme, active }) =>
    active ? theme.colors.base700 : theme.icons.callToAction};
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  width: 32px;

  :hover {
    color: ${({ theme, active }) =>
      active ? theme.colors.base700 : theme.icons.callToActionHover};
  }
`;

export {
  CompareProductButtonDesktop,
  CompareProductButtonMobile,
  Title,
  Tooltip,
};
